import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProvinceService {

  constructor(private _http:HttpClient,private router:Router) { }

  getAllProvinceData():Observable<any>{

    let FullUrl = localStorage.getItem('BaseUrl') +"/api/Province/GetAllProvince";
    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };

    return this._http.get(FullUrl,requestOptions );
  }
  getAllProvince():Observable<any>{

    let FullUrl = localStorage.getItem('BaseUrl') +"/api/Province/GetActiveProvince";
    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };

    return this._http.get(FullUrl,requestOptions );
  }

  AddNewProvince(data:any):Observable<any>{
    console.log(data)
    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };
    let FullUrl = localStorage.getItem('BaseUrl')+"/api/Province/AddNewprovince";
    return this._http.post(FullUrl,data,requestOptions);
  }
  UpdateProvince(ProvinceData):Observable<any>{

    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };
    let FullUrl = localStorage.getItem('BaseUrl')+"/api/Province/UpdateDivision";
    let data ={ Id:ProvinceData.Id, ProvinceName:ProvinceData.ProvinceName, IsActive: ProvinceData.IsActive,ProvinceCode:ProvinceData.Code}
    return this._http.post(FullUrl,data,requestOptions);
  }
}
